// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog-item-container{
    width:70%;
    display: flex;
    flex-direction: column;
    margin-left: 15%;
    padding-top: 130px;
   
    
    
}

.blog-item{
    background-color: #fff;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    margin:20px;
    padding:20px 100px;
}

.blog-item-container img{
    width:80%;
    margin-left: 10%;
}

.blog-item-container img:hover{
    transform: scale(1.1);
}

.blog-item-container h2{
    color:#E42727;
    text-align: left;
    margin-bottom: 0px;
}
.blog-item-container h3 {
    color: #E42727;
    text-align: left;
}
.blog-item-container p {
    /* color: #444; */
    text-align: left;
}

.loader-container{
    width:100vw;
    height:80vh;
}

.blog-item-container li{
    text-align: left;
}

.blog-details-back-btn{
    color:#E42727;
    background-color: #fff;
}

.blog-details-back-btn:hover{
    color:#ffa406;
}

@media screen and (max-width:768px){
    .blog-item-container {
            width: 95%;
            display: flex;
            flex-direction: column;
            margin-left: 10px;
            padding-top: 180px;
    
    
    
        }
        .blog-item {
            background-color: #fff;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
            margin: 20px;
            padding: 20px 20px;
        }
        .blog-item-container img {
            width: 90%;
            margin-left: 5%;
        }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/BlogItem.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;;;;AAItB;;AAEA;IACI,sBAAsB;QAClB,yCAAyC;IAC7C,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;YACQ,UAAU;YACV,aAAa;YACb,sBAAsB;YACtB,iBAAiB;YACjB,kBAAkB;;;;QAItB;QACA;YACI,sBAAsB;YACtB,yCAAyC;YACzC,YAAY;YACZ,kBAAkB;QACtB;QACA;YACI,UAAU;YACV,eAAe;QACnB;AACR","sourcesContent":[".blog-item-container{\n    width:70%;\n    display: flex;\n    flex-direction: column;\n    margin-left: 15%;\n    padding-top: 130px;\n   \n    \n    \n}\n\n.blog-item{\n    background-color: #fff;\n        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n    margin:20px;\n    padding:20px 100px;\n}\n\n.blog-item-container img{\n    width:80%;\n    margin-left: 10%;\n}\n\n.blog-item-container img:hover{\n    transform: scale(1.1);\n}\n\n.blog-item-container h2{\n    color:#E42727;\n    text-align: left;\n    margin-bottom: 0px;\n}\n.blog-item-container h3 {\n    color: #E42727;\n    text-align: left;\n}\n.blog-item-container p {\n    /* color: #444; */\n    text-align: left;\n}\n\n.loader-container{\n    width:100vw;\n    height:80vh;\n}\n\n.blog-item-container li{\n    text-align: left;\n}\n\n.blog-details-back-btn{\n    color:#E42727;\n    background-color: #fff;\n}\n\n.blog-details-back-btn:hover{\n    color:#ffa406;\n}\n\n@media screen and (max-width:768px){\n    .blog-item-container {\n            width: 95%;\n            display: flex;\n            flex-direction: column;\n            margin-left: 10px;\n            padding-top: 180px;\n    \n    \n    \n        }\n        .blog-item {\n            background-color: #fff;\n            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n            margin: 20px;\n            padding: 20px 20px;\n        }\n        .blog-item-container img {\n            width: 90%;\n            margin-left: 5%;\n        }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
